import { render, staticRenderFns } from "./priceCompete.vue?vue&type=template&id=a73b1a4c&scoped=true"
import script from "./priceCompete.vue?vue&type=script&lang=js"
export * from "./priceCompete.vue?vue&type=script&lang=js"
import style0 from "./priceCompete.vue?vue&type=style&index=0&id=a73b1a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73b1a4c",
  null
  
)

export default component.exports